import styled from 'styled-components'
import { ClinTheme } from '../../../../ClinTheme/ClinTheme'

export const StyledEstimatedDeliveryDate = styled.div({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: `${ClinTheme.space[2]}px 0`
})

export const StyledEstimatedDeliveryText = styled.div({
  marginLeft: ClinTheme.space[3],
  width: '100%'
})

export const StyledTooltip = styled.div({
  position: 'absolute',
  top: '1px',
  left: ClinTheme.space[2]
})

export const StyledCutOffText = styled.span({
  fontSize: ClinTheme.fontSizes[0],
  lineHeight: ClinTheme.lineHeights.largeParagraph
})

export const StyledExpecterDeliveryTimeText = styled.span({
  lineHeight: ClinTheme.lineHeights.heading[0],
  fontWeight: ClinTheme.fontWeights.medium
})
